import type { GeolocationsItems } from '@generated/graphql'
import { useEffect } from 'react'
import CloseGeoIcon from 'src/components/ui/Icons/CloseGeoLocator'
import InnerIcon from 'src/components/ui/Icons/GeoLocatorInnerIcon'
import GeoPromoIcon from 'src/components/ui/Icons/GeoLocatorPromotionIcon'
import { sessionStore, validateSession } from 'src/sdk/session'
import { getSellerData } from 'src/utils/getGeolocations'

import { useGeolocations } from '../../hooks/useGeolocations'

interface Props {
  selectedOption: string
  setShowGeo: (value: boolean) => void
  setSelectedOption: (value: string) => void
  newLocationData: LocationsCookie
  setNewLocationData: (value: LocationsCookie) => void
}

const GeoLocatorModal = ({
  setShowGeo,
  setSelectedOption,
  selectedOption,
  newLocationData,
  setNewLocationData,
}: Props) => {
  const locations: GeolocationsItems[] = useGeolocations()

  const session = {
    currency: {
      code: '$',
      symbol: '$',
    },
    locale: 'es-UY',
    channel: '{"salesChannel":"4","regionId":""}',
    country: 'URY',
    postalCode: null,
    person: null,
  }

  const locationData = JSON.parse(localStorage.getItem('Location') ?? '{}')

  const handleGeolocatorSubmit = async () => {
    setShowGeo(false)
    localStorage.setItem(
      'Location',
      JSON.stringify(getSellerData(selectedOption))
    )

    try {
      await validateSession({
        ...session,
        postalCode: newLocationData?.postalCode,
      }).then((newSession) => {
        if (newSession) {
          sessionStore.set(newSession)
          window.location.reload()
        }
      })
    } catch (error) {
      throw new Error(error)
    }
  }

  useEffect(() => {
    setNewLocationData(getSellerData(selectedOption))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption])

  return (
    <div className="geo__body-wrapper">
      <div className="geoLocator-modal-container">
        <div className="geoLocator">
          <div className="geoLocator-innerContainer">
            <div className="geoLocator-close-modal-container">
              <p className="geoLocator-title">¡Bienvenido!</p>
              {!!Object.keys(locationData).length && (
                <button
                  className="geoLocator-close-modal-icon-container"
                  onClick={() => {
                    setShowGeo(false)
                    setSelectedOption(locationData?.description ?? '')
                  }}
                >
                  <CloseGeoIcon />
                </button>
              )}
            </div>
            <InnerIcon />
            <p className="geoLocator-select-text">
              Seleccioná una localidad para iniciar la compra.
            </p>

            <select
              className={`geoLocator-select ${
                selectedOption === '' || selectedOption === 'Ta-Ta'
                  ? 'geoLocator-select__disable'
                  : ''
              }`}
              value={selectedOption}
              onChange={(event) => {
                setSelectedOption(event.target.value)
              }}
            >
              <option>Seleccionar localidad</option>
              {locations?.map((location) => {
                const locationName = location?.name ?? ''

                const mockedSellerData = getSellerData(locationName)

                return (
                  mockedSellerData && (
                    <option value={locationName} key={locationName}>
                      {mockedSellerData.description}
                    </option>
                  )
                )
              })}
            </select>

            <button
              type="button"
              className="geoLocator-button"
              disabled={
                selectedOption === '' ||
                selectedOption === 'Ta-Ta' ||
                selectedOption === 'Seleccionar localidad'
              }
              onClick={() => {
                handleGeolocatorSubmit()
              }}
              aria-label="Geolocator Button"
            >
              Confirmar
            </button>

            {locationData && (
              <div className="geoLocator-promotions-container">
                <GeoPromoIcon />
                <p className="geoLocator-promotionalPrices">
                  Los precios y promociones son exclusivos online
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default GeoLocatorModal
